/* eslint-disable sonarjs/no-duplicate-string */
'use client';
import { ProductCardImage, Typography } from '@curology/ui-components-web';
import { CircleCheckmarkIcon, SunIcon } from 'radiance-ui/lib/icons';
import Slider from 'react-slick';

import './css/carousel.css';

const images = [
  {
    url: 'https://images.ctfassets.net/8pzh4g8cs30t/RWgibjv58gxS6GNy0GBnx/b48ad44aa0a8257b03e092f02a4e7b76/01.jpg',
  },
  {
    url: 'https://images.ctfassets.net/8pzh4g8cs30t/1O1D4KsvIRlYX85tznTcBZ/543ec701b84fd92e390c1a3d2b550f10/02.jpg',
  },
  {
    url: 'https://images.ctfassets.net/8pzh4g8cs30t/1xq20u8MoKyCd5BUGC5hY7/f44c0a50fe3f6b5b20fb7a2ab043a88f/03.jpg',
  },
  {
    url: 'https://images.ctfassets.net/8pzh4g8cs30t/1y9bxisGtUPgzEixmNzZ8e/00d653be356eff68b231055f9c557869/04.jpg',
  },
  {
    url: 'https://images.ctfassets.net/8pzh4g8cs30t/5H1pBqiNZl3eiLJGfhXNVS/f16595996e42a7ca87f0a8d620c427eb/05.jpg',
  },
];

const ProductHeroCarousel = () => {
  return (
    <div className="product-card-image-carousel-container">
      <Slider
        accessibility={true}
        arrows={false}
        dots={true}
        draggable={true}
        infinite={true}
      >
        {images.map((image) => {
          return (
            <ProductCardImage
              alt={'Example product image'}
              aspectRatio="3:2"
              className="cur-cursor-default"
              key={image.url}
              onClick={(event) => event.stopPropagation()}
              src={image.url}
            />
          );
        })}
      </Slider>
    </div>
  );
};

const ProductCard = () => {
  return (
    <div className="cur-flex cur-flex-col cur-bg-white">
      <div className="cur-relative cur-p-1">
        <div className="cur-relative">
          <div className="cur-absolute cur-z-20 cur-flex cur-gap-[6px] cur-top-0 cur-left-0 cur-m-[4px]">
            <span className="cur-h-[20px] cur-inline-flex cur-items-center cur-bg-surface-brand-accent cur-px-2 cur-py-[4px] cur-text-meta cur-font-bold text-gray-600">
              Blur and treat
            </span>
            <span className="cur-h-[20px] cur-inline-flex cur-items-center cur-bg-surface-primary cur-px-2 cur-py-[4px] cur-text-meta cur-font-bold text-gray-600">
              <SunIcon className="cur-w-3 cur-h-3 cur-mr-1" /> AM
            </span>
            <span className="cur-h-[20px] cur-inline-flex cur-items-center cur-bg-surface-primary cur-rounded-full cur-px-2 cur-py-[4px] cur-text-meta cur-font-bold text-gray-600 cur-uppercase cur-tracking-[.5px]">
              <CircleCheckmarkIcon className="cur-w-3 cur-h-3 cur-mr-1 cur-text-vivid-purple" />{' '}
              HSA/FSA Eligible
            </span>
          </div>
          <ProductHeroCarousel />
        </div>
      </div>
      <div className="cur-py-4 cur-px-4">
        <div className="cur-cursor-pointer">
          <div className="cur-flex cur-justify-between cur-items-center">
            <Typography size="h3">
              DayPrime<sup>Rx</sup>
            </Typography>
          </div>
          <div className="cur-flex cur-items-center cur-mt-1">
            <Typography size="subhead" className="cur-font-bold">
              Free{' '}
              <span className="cur-line-through cur-font-normal cur-text-[#B9B9C5]">
                $29.95
              </span>{' '}
              <span className="cur-font-normal">(30-day supply)</span>
            </Typography>
          </div>
          <Typography className="cur-mt-1" size="body">
            Get soft-focus, smoother-looking skin and help treat acne with
            personalized Rx active ingredients in this 2-in-1 daytime acne
            treatment and primer.
          </Typography>
        </div>
      </div>
    </div>
  );
};

export { ProductCard };
